
/* invio dei moduli a Shopify: clienti (iscrizione) o messaggio di contatto */
function hrNative(fields,fid){var f=document.createElement('form');f.method='post';f.action='/contact#'+(fid||'');f.acceptCharset='UTF-8';fields.utf8='✓';for(var k in fields){var i=document.createElement('input');i.type='hidden';i.name=k;i.value=fields[k];f.appendChild(i);}document.body.appendChild(f);f.submit();}
function hrPost(fields,fid){
  /* invio classico del modulo Shopify (con la protezione antispam di Shopify), non via fetch */
  var f=document.getElementById(fid);
  if(!f||f.tagName!=='FORM'||!f.querySelector('input[name=form_type]')){hrNative(fields,fid);return new Promise(function(){});}
  for(var k in fields){if(k==='form_type'||k==='utf8')continue;var el=f.querySelector('[name="'+k+'"]');if(!el){el=document.createElement('input');el.type='hidden';el.name=k;f.appendChild(el);}if(el.type!=='radio'&&el.type!=='checkbox')el.value=fields[k];}
  f.dataset.go='1';
  setTimeout(function(){if(f.requestSubmit)f.requestSubmit();else f.submit();},0);
  return new Promise(function(){});
}
function hrToast(t){var d=document.createElement('div');d.className='hr-toast';d.setAttribute('role','status');d.textContent=t;document.body.appendChild(d);setTimeout(function(){d.remove();},6000);}
function hrReturn(){
  var s=location.search;if(!/(customer|contact)_posted=true/.test(s))return;
  var f=location.hash&&document.querySelector(location.hash);
  if(f&&f.querySelector&&f.querySelector('[data-done]')){f.querySelector('[data-open]').hidden=true;f.querySelector('[data-done]').hidden=false;}
  else hrToast(/contact_posted/.test(s)?'Messaggio inviato. Ti rispondiamo presto.':'Iscrizione ricevuta. Grazie.');
}
function hrVal(id){var e=document.getElementById(id);return e?e.value.trim():'';}

(function(){
  var root=document.documentElement;
  var reduce=root.classList.contains('reduce');
  var hasG=!!(window.gsap&&window.ScrollTrigger);
  if(!hasG){root.classList.add('reduce');reduce=true;}

  /* dati dei manuali */
  var VOL=[
    {k:'pelle',t:'La Mia Pelle',s:'Dermatologia estetica',img:'/cdn/shop/files/hr2-t-vol-la-mia-pelle.webp',glow:'#E2A5B6',x:'28%',y:'30%'},
    {k:'cosmetici',t:'I Miei Cosmetici',s:'Cosmetologia estetica a base naturale',img:'/cdn/shop/files/hr2-t-vol-i-miei-cosmetici.webp',glow:'#EF9FB0',x:'64%',y:'26%'},
    {k:'estetica',t:'Estetica Pratica',s:'Pratica professionale',img:'/cdn/shop/files/hr2-t-vol-estetica-pratica.webp',glow:'#C95A6E',x:'34%',y:'60%'},
    {k:'corpo',t:'Il Mio Corpo',s:'Anatomia e fisiologia del corpo umano',img:'/cdn/shop/files/hr2-t-vol-il-mio-corpo.webp',glow:'#EF7F7F',x:'62%',y:'48%'},
    {k:'app',t:'Guida pratica alle apparecchiature estetiche',s:"L'uso delle apparecchiature in cabina",img:'/cdn/shop/files/hr2-t-vol-apparecchiature.webp',glow:'#C199DB',x:'40%',y:'40%'}
  ];
  var track=document.getElementById('track');
  track.innerHTML=VOL.map(function(v,i){
    return '<article class="vol" style="--glow:'+v.glow+'">'+
      '<div class="vol__art"><img src="'+v.img+'" alt="Copertina del manuale '+v.t+'" width="720" height="900" loading="lazy"><span class="vol__dot" style="left:'+v.x+';top:'+v.y+'" aria-hidden="true"></span></div>'+
      '<div class="vol__info"><span class="vol__n">0'+(i+1)+' / 05</span><h3 class="h3">'+v.t+'</h3><span class="vol__s">'+v.s+'</span>'+
      '<div class="vol__buy"><span class="vol__p">38,00 euro</span><button class="btn" type="button" data-add="'+v.k+'" aria-pressed="false"><span>Aggiungi</span><span class="arr" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M7 2v10M2 7h10"/></svg></span></button></div></div></article>';
  }).join('');

  /* carrello vero di Shopify */
  var VID={pelle:58355936067915,cosmetici:58355936100683,estetica:58355936133451,corpo:58355937182027,app:58355937214795};
  var KEY={};for(var kk in VID)KEY[VID[kk]]=kk;
  var cart={},cartTot=0,cartCount=0;
  function eur(v){return v.toFixed(2).replace('.',',')+' euro';}
  function renderCart(){
    var n=cartCount;
    document.getElementById('cartN').textContent=n;
    var c=document.getElementById('cart');c.classList.toggle('has',n>0);c.setAttribute('aria-label','Carrello, '+n+(n===1?' articolo':' articoli'));
    var rest=Math.max(0,65-cartTot);
    document.getElementById('shipBar').style.width=Math.min(100,cartTot/65*100)+'%';
    var m=document.getElementById('shipMsg');
    if(!n){m.textContent="Spedizione gratuita in Italia e nell'Unione Europea da due manuali.";}
    else{m.innerHTML='Nel carrello '+eur(cartTot)+'. '+(rest>0?'Con un altro manuale la spedizione è gratuita.':'Spedizione gratuita.')+' <a href="/cart">Vai al carrello</a>';}
    track.querySelectorAll('[data-add]').forEach(function(b){var on=!!cart[b.getAttribute('data-add')];b.classList.toggle('is-in',on);b.setAttribute('aria-pressed',String(on));b.firstChild.textContent=on?'Nel carrello':'Aggiungi';});
  }
  function syncCart(c){cart={};(c.items||[]).forEach(function(it){var k=KEY[it.variant_id];if(k)cart[k]=it.quantity;});cartTot=(c.total_price||0)/100;cartCount=c.item_count||0;renderCart();}
  function loadCart(){return fetch('/cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(syncCart).catch(function(){});}
  var JH={'Content-Type':'application/json',Accept:'application/json'};
  track.addEventListener('click',function(e){
    var b=e.target.closest('[data-add]');if(!b||b.disabled)return;
    var k=b.getAttribute('data-add');b.disabled=true;
    var req=cart[k]?fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:JH,body:JSON.stringify({id:String(VID[k]),quantity:0})})
                   :fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:JH,body:JSON.stringify({items:[{id:VID[k],quantity:1}]})});
    req.then(loadCart).catch(function(){hrToast('Non siamo riusciti ad aggiornare il carrello. Riprova.');}).then(function(){b.disabled=false;});
  });
  loadCart();

  /* fisarmoniche */
  function accordion(id,single,onOpen){
    var box=document.getElementById(id);
    box.addEventListener('click',function(e){
      var b=e.target.closest('.acc__b');if(!b)return;
      var open=b.getAttribute('aria-expanded')!=='true';
      if(single)box.querySelectorAll('.acc__b').forEach(function(x){x.setAttribute('aria-expanded','false');});
      b.setAttribute('aria-expanded',String(open||single));
      if(onOpen)onOpen(b);
    });
  }
  var vis=document.querySelectorAll('#proVis img');
  accordion('acc',true,function(b){var i=+b.getAttribute('data-img');vis.forEach(function(im,j){im.classList.toggle('on',i===j);});});
  accordion('faq',false);

  /* moduli: validazione dopo l'uscita dal campo, poi invio simulato */
  function setupForm(id){
    var f=document.getElementById(id);
    function check(inp){
      var s=inp.parentNode.querySelector('small'),m='';
      if(!inp.value.trim())m='Questo campo serve per risponderti.';
      else if(inp.type==='email'&&!/^\S+@\S+\.\S+$/.test(inp.value))m="Controlla l'indirizzo: manca qualcosa.";
      if(s)s.textContent=m;return !m;
    }
    f.querySelectorAll('input[required]').forEach(function(i){i.addEventListener('blur',function(){if(i.value)check(i);});});
    f.addEventListener('submit',function(e){
      if(e.target.dataset.go)return;e.preventDefault();
      var bad=null;f.querySelectorAll('input[required]').forEach(function(i){if(!check(i)&&!bad)bad=i;});
      if(bad){bad.focus();return;}
      var btn=f.querySelector('button[type=submit]');btn.disabled=true;btn.firstChild.textContent='Invio in corso';
      var fields;
      if(id==='proForm'){fields={form_type:'contact','contact[name]':hrVal('p-nome'),'contact[email]':hrVal('p-mail'),'contact[body]':'Richiesta delle condizioni professionali dalla pagina Le Allieve. Centro e città: '+hrVal('p-centro')};}
      else{var pr=f.querySelector('input[name=profilo]:checked');fields={form_type:'customer','contact[email]':hrVal('j-mail'),'contact[tags]':'newsletter, allieve'+(pr?', allieve-'+pr.value:'')};}
      var label=id==='proForm'?'Invia la richiesta':'Entra tra le Allieve';
      hrPost(fields,id).then(function(){f.querySelector('[data-open]').hidden=true;f.querySelector('[data-done]').hidden=false;if(id==='joinForm'){dockOff=true;document.getElementById('dock').classList.remove('is-on');}})
        .catch(function(){btn.disabled=false;btn.firstChild.textContent=label;hrToast('Invio non riuscito. Controlla la connessione e riprova.');});
    });
  }
  setupForm('proForm');setupForm('joinForm');
  document.getElementById('hrfForm').addEventListener('submit',function(e){if(e.target.dataset.go)return;e.preventDefault();var i=document.getElementById('hrf-mail'),m=this.querySelector('.hrf__msg');if(!/^\S+@\S+\.\S+$/.test(i.value)){m.textContent="Controlla l'indirizzo email.";i.focus();return;}var em=i.value.trim();m.textContent='Invio in corso';hrPost({form_type:'customer','contact[email]':em,'contact[tags]':'newsletter, footer'},'hrfForm').then(function(){m.textContent='Grazie, sei iscritta alla newsletter.';i.value='';}).catch(function(){m.textContent='Invio non riuscito, riprova.';});});
  var dockOff=false;
  hrReturn();

  /* copia indirizzo */
  document.getElementById('copyMail').addEventListener('click',function(){
    var b=this,t=document.getElementById('mailTxt').textContent;
    function sel(){var r=document.createRange();r.selectNodeContents(document.getElementById('mailTxt'));var s=getSelection();s.removeAllRanges();s.addRange(r);b.textContent='Selezionato';}
    try{navigator.clipboard.writeText(t).then(function(){b.textContent='Copiato';},sel);}catch(e){sel();}
  });

  /* percorsi: preseleziona il profilo e porta alla sezione */
  var lenis=null;
  function goTo(sel){
    var el=document.querySelector(sel);if(!el)return;
    if(lenis){lenis.scrollTo(el,{offset:-72,duration:1.4});}else{el.scrollIntoView({behavior:reduce?'auto':'smooth'});}
  }
  document.querySelectorAll('[data-path]').forEach(function(c){
    c.addEventListener('click',function(){
      var r=document.getElementById('r-'+c.getAttribute('data-path'));if(r)r.checked=true;
      goTo(c.getAttribute('data-go'));
    });
  });
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click',function(e){var h=a.getAttribute('href');if(h.length>1){e.preventDefault();goTo(h);}});
  });

  /* barra in basso e intestazione */
  var hdr=document.getElementById('hdr'),dock=document.getElementById('dock'),lastY=0;
  function onScroll(y){
    hdr.classList.toggle('is-solid',y>8);
    lastY=y;
    var joinTop=document.getElementById('allieve').getBoundingClientRect().top;
    dock.classList.toggle('is-on',!dockOff&&y>innerHeight*.9&&joinTop>innerHeight*.6);
  }
  addEventListener('scroll',function(){onScroll(scrollY);},{passive:true});

  /* menu a scomparsa su telefono e tablet */
  (function(){
    var bt=document.getElementById('burger'),mn=document.getElementById('mnav'),hr=document.querySelector('.hdr__r');
    if(!bt&&hr){hr.insertAdjacentHTML('beforeend','<button class="burger" id="burger" type="button" aria-label="Apri il menu" aria-expanded="false" aria-controls="mnav"><span></span><span></span></button>');bt=document.getElementById('burger');}
    if(!mn){hdr.insertAdjacentHTML('afterend','<div class="mnav" id="mnav"><nav aria-label="Menu"></nav></div>');mn=document.getElementById('mnav');}
    if(!bt||!mn)return;
    var nv=document.querySelector('.hdr nav');mn.querySelector('nav').innerHTML=nv?nv.innerHTML:'';
    var cta=document.querySelector('.hdr__r>.btn');if(cta)mn.appendChild(cta.cloneNode(true));
    function set(o){
      bt.setAttribute('aria-expanded',String(o));bt.setAttribute('aria-label',o?'Chiudi il menu':'Apri il menu');
      mn.classList.toggle('is-open',o);mn.inert=!o;root.classList.toggle('menu-open',o);
      if(lenis){if(o)lenis.stop();else lenis.start();}
      if(o)hdr.classList.add('is-solid');else onScroll(lenis?lenis.scroll:scrollY);
    }
    mn.inert=true;
    bt.addEventListener('click',function(){set(bt.getAttribute('aria-expanded')!=='true');});
    mn.addEventListener('click',function(e){var a=e.target.closest('a');if(!a)return;var h=a.getAttribute('href')||'';set(false);if(h.charAt(0)==='#'&&h.length>1){e.preventDefault();setTimeout(function(){goTo(h);},60);}});
    addEventListener('keydown',function(e){if(e.key==='Escape'&&mn.classList.contains('is-open')){set(false);bt.focus();}});
    var mq=matchMedia('(min-width: 900px)');if(mq.addEventListener)mq.addEventListener('change',function(m){if(m.matches)set(false);});
  })();

  /* divisione dei titoli in parole mascherate */
  document.querySelectorAll('[data-split]').forEach(function(h){
    if(!h.closest('#hero-t'))h.setAttribute('aria-label',h.textContent);
    h.innerHTML=h.textContent.split(' ').map(function(w){return '<span class="w" aria-hidden="true"><span>'+w+'</span></span>';}).join(' ');
  });

  var loader=document.getElementById('loader');
  if(reduce){loader.remove();renderCart();return;}

  gsap.registerPlugin(ScrollTrigger);

  /* scorrimento morbido */
  if(window.Lenis){
    lenis=new Lenis({lerp:.09,smoothWheel:true});
    lenis.on('scroll',function(e){ScrollTrigger.update();onScroll(e.scroll);});
    gsap.ticker.add(function(t){lenis.raf(t*1000);});
    gsap.ticker.lagSmoothing(0);
  }

  /* ingresso: contatore, logo, sipario */
  var seen=false;try{seen=sessionStorage.getItem('hr_acc_intro')==='1';sessionStorage.setItem('hr_acc_intro','1');}catch(e){}
  var heroWords=document.querySelectorAll('#hero-t .w>span');
  gsap.set(heroWords,{yPercent:110});
  gsap.set('[data-hero]',{opacity:0,y:24});
  gsap.set('#books img',{yPercent:60,opacity:0});
  var intro=gsap.timeline({delay:.05});
  if(!seen){
    var o={n:0};
    intro.to(loader.querySelector('img'),{opacity:1,duration:.5,ease:'power2.out'},0)
         .to(o,{n:100,duration:1.05,ease:'power2.inOut',onUpdate:function(){document.getElementById('loaderN').textContent=Math.round(o.n)+'%';}},0)
         .to(loader,{yPercent:-100,duration:.9,ease:'expo.inOut'},1.15)
         .set(loader,{display:'none'});
  }else{loader.remove();}
  var t0=seen?0:1.45;
  intro.to('[data-hero="util"]',{opacity:1,y:0,duration:.8,ease:'power3.out'},t0)
       .to(heroWords,{yPercent:0,duration:1.1,ease:'expo.out',stagger:.045},t0+.05)
       .to('#books img',{yPercent:0,opacity:1,duration:1.4,ease:'expo.out',stagger:.08},t0+.15)
       .to('[data-hero="eyebrow"],[data-hero="lead"],[data-hero="cta"]',{opacity:1,y:0,duration:.9,ease:'power3.out',stagger:.08},t0+.45);

  /* ombre che respirano lentamente, ferme quando l'apertura non si vede */
  var drift=gsap.timeline({repeat:-1,yoyo:true,defaults:{ease:'sine.inOut',duration:7}});
  drift.to('.hero__shadows i:nth-child(1)',{xPercent:18,rotation:-10},0).to('.hero__shadows i:nth-child(2)',{xPercent:-30},0).to('.hero__shadows i:nth-child(3)',{xPercent:-14,rotation:28},0);
  ScrollTrigger.create({trigger:'.hero',start:'top top',end:'bottom top',onToggle:function(s){s.isActive?drift.play():drift.pause();}});

  /* apertura che si allontana scorrendo */
  gsap.to('#books',{yPercent:-14,ease:'none',scrollTrigger:{trigger:'.hero',start:'top top',end:'bottom top',scrub:true}});
  gsap.to('.hero__copy',{yPercent:-10,opacity:.2,ease:'none',scrollTrigger:{trigger:'.hero',start:'center top',end:'bottom top',scrub:true}});

  /* titoli di sezione: parole che salgono */
  document.querySelectorAll('[data-split]').forEach(function(h){
    if(h.closest('#hero-t'))return;
    gsap.from(h.querySelectorAll('.w>span'),{yPercent:110,duration:1,ease:'expo.out',stagger:.035,scrollTrigger:{trigger:h,start:'top 85%'}});
  });
  /* blocchi che entrano */
  ScrollTrigger.batch('[data-r]',{start:'top 88%',once:true,onEnter:function(els){gsap.to(els,{opacity:1,y:0,duration:.9,ease:'power3.out',stagger:.07,overwrite:true});}});

  /* racconto bloccato: tre frasi */
  var phr=gsap.utils.toArray('[data-phr]'),cards=gsap.utils.toArray('[data-card]');
  gsap.set(phr.concat(cards),{opacity:0,y:50});
  gsap.set([phr[0],cards[0]],{opacity:1,y:0});
  var st=gsap.timeline({defaults:{ease:'power2.inOut'},scrollTrigger:{trigger:'#metodo',start:'top top',end:'+=220%',pin:true,scrub:.6,
    onUpdate:function(s){var i=Math.min(2,Math.floor(s.progress*3));document.getElementById('storyN').textContent='0'+(i+1)+' / 03';}}});
  st.fromTo('#storyImg',{scale:1.18},{scale:1,ease:'none',duration:3},0)
    .fromTo('#storyBar',{scaleX:0},{scaleX:1,ease:'none',duration:3},0)
    .to([phr[0],cards[0]],{opacity:0,y:-50,duration:.3,ease:'power2.in'},.7)
    .to([phr[1],cards[1]],{opacity:1,y:0,duration:.35,ease:'power2.out'},1.02)
    .to([phr[1],cards[1]],{opacity:0,y:-50,duration:.3,ease:'power2.in'},1.7)
    .to([phr[2],cards[2]],{opacity:1,y:0,duration:.35,ease:'power2.out'},2.02);

  /* manuali: binario orizzontale su schermi larghi */
  var mm=gsap.matchMedia();
  mm.add('(min-width: 900px)',function(){
    var dist=function(){return track.scrollWidth-innerWidth;};
    gsap.to(track,{x:function(){return -dist();},ease:'none',scrollTrigger:{trigger:'#manuali',start:'top top',end:function(){return '+='+dist();},pin:true,scrub:.6,invalidateOnRefresh:true}});
  });
  mm.add('(max-width: 899px)',function(){
    gsap.utils.toArray('.vol').forEach(function(v){gsap.from(v,{y:60,opacity:0,duration:1,ease:'power3.out',scrollTrigger:{trigger:v,start:'top 88%'}});});
  });

  /* scritta che scorre con la pagina */
  gsap.fromTo('#marq',{xPercent:2},{xPercent:-38,ease:'none',scrollTrigger:{trigger:'.marq',start:'top bottom',end:'bottom top',scrub:true}});

  renderCart();
  addEventListener('load',function(){ScrollTrigger.refresh();});
})();
